
const getters = {
  isType: state => state.home.isType,
  ActiveName: state => state.home.ActiveName,
  isHome: state => state.home.isHome
}
export default getters
